import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';
import {
  breakpointSizes,
  maxBreakpointQuery,
  minBreakpointQuery,
  sectionMargins,
} from '../styles';
import { Button, Container, Heading, Slider } from './ui';
import CommunityStoryCard from './CommunityStoryCard';

const StyledFeaturedCommunityStories = styled.section`
  ${sectionMargins('80px', '110px')}
  overflow: hidden;
`;

const StyledHeading = styled(Heading)`
  text-align: center;
`;

const StyledItemsWrapper = styled.div`
  margin-top: 30px;

  ${minBreakpointQuery.small`
    margin-top: 40px
  `}

  ${minBreakpointQuery.large`
    margin-top: 50px
  `}
`;
const StyledItems = styled(Slider)`
  margin: 0 40px;

  ${maxBreakpointQuery.xxxxlarge`
    overflow: visible;
  `}

  ${minBreakpointQuery.tiny`
    margin: 0 50px;
  `}

  ${minBreakpointQuery.tsmall`
    margin: 0 60px;
  `}

  ${minBreakpointQuery.small`
    margin: 0 70px;
  `}

  ${minBreakpointQuery.medium`
    margin: 0 80px;
  `}

  ${minBreakpointQuery.large`
    margin: 0 90px;
  `}

  ${minBreakpointQuery.xxlarge`
    margin: 0 100px;
  `}

  ${minBreakpointQuery.xxxxlarge`
    margin: 0;
  `}

  .swiper-container {
    width: 100%;
  }

  .swiper-slide {
    width: auto;
    height: auto;
  }
`;

const StyledItem = styled(CommunityStoryCard)``;

const StyledButtonWrapper = styled.div`
  text-align: center;
`;

const StyledButton = styled(Button)`
  margin-top: 30px;
  width: 100%;
  max-width: 480px;

  ${minBreakpointQuery.small`
    margin-top: 45px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 60px;
  `}
`;

const FeaturedCommunityStories = ({ heading, items: initialItems }) => {
  const {
    contentfulCommunityStories,
    allContentfulCommunityStory: { communityStories },
  } = useStaticQuery(graphql`
    query FeaturedCommunityStoriesQuery {
      contentfulCommunityStories {
        ...LinkFragment
      }
      allContentfulCommunityStory(limit: 8, sort: { publishedDate: DESC }) {
        communityStories: nodes {
          ...CommunityStoryCardFragment
        }
      }
    }
  `);

  const items = initialItems ? initialItems : communityStories;

  const sliderOptions = {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    breakpoints: {
      [breakpointSizes.tiny]: { spaceBetween: 30 },
      [breakpointSizes.smedium]: { slidesPerView: 2 },
      [breakpointSizes.xlarge]: { slidesPerView: 3 },
      [breakpointSizes.xxxlarge]: { slidesPerView: 4 },
      [breakpointSizes.xxxxlarge]: { slidesPerView: 5 },
    },
  };

  return (
    <StyledFeaturedCommunityStories>
      <Container wide={true}>
        <StyledHeading>
          {heading || 'Ecotalk Community - mobilising change'}
        </StyledHeading>
        <StyledItemsWrapper>
          <StyledItems {...sliderOptions}>
            {items.map((item, id) => (
              <StyledItem key={id} {...item} />
            ))}
          </StyledItems>
        </StyledItemsWrapper>
        <StyledButtonWrapper>
          <StyledButton to={contentfulCommunityStories} hasArrow={true}>
            Read our stories
          </StyledButton>
        </StyledButtonWrapper>
      </Container>
    </StyledFeaturedCommunityStories>
  );
};

export default FeaturedCommunityStories;
